'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import { Container, Box } from './styled.js';
import { ELanguage } from '../Utils/constants.js';
import { getXaloLead } from '../services/xaloLead/index.js';
import Col from '../LayoutSystem/Col.js';
import Row from '../LayoutSystem/Row.js';
import Button from '../Button/index.js';
import { getCookie } from '../Utils/cookie.js';
import XaloLeadInformation from './components/XaloLeadInformation.js';
import FormRegisterXaloLead from './components/FormRegisterXaloLead.js';
import Alert from '../Alert/index.js';
import { TRIGGER_HASH } from './const.js';
import { buildLoginUrl } from '../Utils/urlBuilder.js';

var XaloLead = function (_a) {
    var _b, _c, _d, _e, _f;
    var baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, _g = _a.langCode, langCode = _g === void 0 ? ELanguage.VI : _g, user = _a.user;
    var _h = useState(null), xaloLead = _h[0], setXaloLead = _h[1];
    var _j = useState(false), activeForm = _j[0], setActiveForm = _j[1];
    var _k = useState(false), isSuccess = _k[0], setIsSuccess = _k[1];
    var ref = useRef(null);
    var xaloLeadRegistered = getCookie('xaloLeadRegistered');
    var isXaloLeadRegistered = Number(xaloLeadRegistered) === (user === null || user === void 0 ? void 0 : user.userId);
    var xaloleadInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var info, error_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getXaloLead(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', langCode)];
                case 1:
                    info = _e.sent();
                    if (info) {
                        setXaloLead(__assign(__assign({}, info), { benefits: [
                                (_a = info.popupPoint1Title) !== null && _a !== void 0 ? _a : '',
                                (_b = info.popupPoint2Title) !== null && _b !== void 0 ? _b : '',
                                (_c = info.popupPoint3Title) !== null && _c !== void 0 ? _c : '',
                                (_d = info.popupPoint4Title) !== null && _d !== void 0 ? _d : ''
                            ] }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _e.sent();
                    throw Error(error_1);
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        xaloleadInfo();
    }, []);
    if (isXaloLeadRegistered && !isSuccess) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var formData = {
        txtCMBFullName: "".concat((_b = user === null || user === void 0 ? void 0 : user.firstName) !== null && _b !== void 0 ? _b : '', " ").concat((_c = user === null || user === void 0 ? void 0 : user.lastName) !== null && _c !== void 0 ? _c : ''),
        txtCMBEmail: (_d = user === null || user === void 0 ? void 0 : user.userName) !== null && _d !== void 0 ? _d : '',
        txtCMBCellphone: (_e = user === null || user === void 0 ? void 0 : user.phone) !== null && _e !== void 0 ? _e : '',
        txtCMBYearExp: '',
        txtCMBAddress: '',
        chkCMBAgreeTerm: 'on',
        action: 'sendLead',
        txtCMBEnLevel: 'None Require'
    };
    return (React__default.createElement(Container, null, isSuccess ? (React__default.createElement(Alert, { isHaveClose: false, type: 'success' }, "C\u1EA3m \u01A1n b\u1EA1n \u0111\u00E3 \u0111\u0103ng k\u00FD ch\u01B0\u01A1ng tr\u00ECnh. Ch\u00FAng t\u00F4i s\u1EBD li\u00EAn h\u1EC7 l\u1EA1i v\u1EDBi b\u1EA1n s\u1EDBm")) : (React__default.createElement(Row, { gutter: 18, justify: 'center' },
        xaloLead ? React__default.createElement(XaloLeadInformation, { xaloLead: xaloLead }) : null,
        user ? (React__default.createElement(FormRegisterXaloLead, { ref: ref, baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', formData: formData, xaloLead: xaloLead, active: activeForm, setIsSuccess: setIsSuccess, user: user })) : null,
        React__default.createElement(Col, { xs: 24 },
            React__default.createElement(Box, null,
                React__default.createElement(Button, { htmlType: 'submit', type: 'primary', onClick: function () {
                        if (!user || !user.userId) {
                            var loginUrl = "".concat(baseUrl, "/").concat(langCode === ELanguage.EN ? 'login?from=home-v2' : 'dang-nhap?from=home-v2').concat(TRIGGER_HASH);
                            window.location.assign(buildLoginUrl(loginUrl));
                            return;
                        }
                        if (!activeForm || !ref.current) {
                            setActiveForm(true);
                            return;
                        }
                        ref.current.onSubmit();
                    } }, (_f = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupCallToAction) !== null && _f !== void 0 ? _f : '')))))));
};

export { XaloLead, XaloLead as default };
//# sourceMappingURL=index.js.map
